import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/authentication/auth.service';
import { RestUserService } from 'src/app/service/rest/user/rest-user.service';

@Component({
  selector: 'app-prelogin',
  templateUrl: './prelogin.component.html',
  styleUrls: ['./prelogin.component.scss']
})
export class PreloginComponent implements OnInit {

  constructor(private authService: AuthService,
              private userRestService: RestUserService){}


  ngOnInit(): void {
    this.configure();
  }

  configure(): void {
    this.authService.configureLogin();
  }

}
